import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TSortColumn, TSortDirection } from '../../classes/grid-page-info';
import {
  GQLArguments,
  GQLResponse,
  IGQLResponse,
} from '../../interfaces/graphql.interface';
import { getPayersQuery } from '../../interfaces/payer/payers.graphql';
import {
  IGQLPayersParams,
  IPayer,
} from '../../interfaces/payer/payers.interface';
import { HelperGQLService } from '../helper.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class PayerGQLService {
  constructor(
    private apollo: Apollo,
    private gqlService: HelperGQLService,
  ) {}

  getPayer(payerId: string) {
    return this.apollo
      .watchQuery<IGQLResponse<IPayer>>({
        query: getPayersQuery,
        fetchPolicy: 'no-cache',
        variables: {
          first: 30,
          where: {
            id: { eq: payerId },
          },
        },
      })
      .valueChanges.pipe(
        map((response) => {
          return response.data.payers;
        }),
      );
  }

  getPayers(payersParams?: IGQLPayersParams): Observable<GQLResponse<IPayer>> {
    const { orderby, direction, filter, after } = payersParams ?? {};
    const sortBy: TSortColumn | undefined = orderby;
    const sortDirection: TSortDirection | undefined = direction;

    const gqlArguments: GQLArguments = { first: 30 };

    if (filter) {
      const payersFilters = {
        name: { contains: filter.name },
        processorId: { eq: filter.processorId },
        neicId: { eq: filter.neicId },
        state: { eq: filter.state },
        recordStatus: {
          eq: filter.recordStatus ? filter.recordStatus[0] : null,
        },
        and: filter.and,
        or: filter.or
          ? [
              { neicId: { eq: filter.or.neicId } },
              { name: { contains: filter.or.name } },
            ]
          : null,
        legacy: { eq: filter.legacy },
      };
      gqlArguments.where = this.gqlService.cleanFilterObject(payersFilters);
    }

    if (sortBy && sortDirection) {
      gqlArguments.order = [{ [sortBy]: sortDirection }];
    }
    if (after) {
      gqlArguments.after = after;
    }

    return this.apollo
      .watchQuery<IGQLResponse<IPayer>>({
        query: getPayersQuery,
        fetchPolicy: 'no-cache',
        variables: {
          ...gqlArguments,
        },
      })
      .valueChanges.pipe(
        map((response) => {
          return response.data.payers;
        }),
      );
  }
}
